import { RefOption } from "../../../services/agenda/types";
import { RefOptionsAction } from "../types";

export const refOptionsActions = {
  setLoadingCodes: (loading: boolean): RefOptionsAction => ({
    type: "SET_LOADING_CODES",
    payload: loading,
  }),

  setCodes: (codes: string[]): RefOptionsAction => ({
    type: "SET_CODES",
    payload: codes,
  }),

  setCodesError: (error: string): RefOptionsAction => ({
    type: "SET_CODES_ERROR",
    payload: error,
  }),

  setLoadingOptions: (code: string, loading: boolean): RefOptionsAction => ({
    type: "SET_LOADING_OPTIONS",
    payload: { code, loading },
  }),

  setOptions: (code: string, options: RefOption[]): RefOptionsAction => ({
    type: "SET_OPTIONS",
    payload: { code, options },
  }),

  setOptionsError: (code: string, error: string): RefOptionsAction => ({
    type: "SET_OPTIONS_ERROR",
    payload: { code, error },
  }),

  clearCache: (): RefOptionsAction => ({
    type: "CLEAR_CACHE",
  }),
};
